import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "cart-checkout__bonus" };
const _hoisted_2 = { class: "mb-2 ml-2 mb-2" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "d-flex flex-row p-3" };
const _hoisted_5 = { class: "flex-grow-1 d-flex flex-column" };
const _hoisted_6 = {
    key: 0,
    class: "small mb-2"
};
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("span", { class: "text-muted" }, "Artikelnummer:", -1);
const _hoisted_8 = { key: 1 };
const _hoisted_9 = ["innerHTML"];
const _hoisted_10 = {
    key: 0,
    class: "ms-4 d-flex flex-column justify-content-center"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = { class: "mt-2" };
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
    key: 1,
    class: "ms-4 d-flex flex-column justify-content-center ui-w-40"
};
const _hoisted_15 = {
    key: 0,
    class: "position-absolute top-0 start-100 translate-middle badge rounded-circle bg-success d-flex justify-content-center align-content-center",
    style: { "width": "30px", "height": "30px" }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h6", null, _toDisplayString(_ctx.$tc('client.Commerce.Carts.Bonus')), 1)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema.bonus, (item) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['border position-relative mb-4', _ctx.isItemSelect(item) ? 'border-success bg-success bg-opacity-10' : 'border bg-light']),
                style: { "border-radius": "2px", "cursor": "pointer" },
                onClick: ($event) => (_ctx.selectBonus(item))
            }, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (item.itemNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _hoisted_7,
                                _createTextVNode(" " + _toDisplayString(item.itemNumber), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            class: _normalizeClass(['m-0', item.name != '__' ? 'h5' : 'fw-bold'])
                        }, _toDisplayString(item.caption1), 3),
                        (item.caption2)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.caption2), 1))
                            : _createCommentVNode("", true),
                        (item.description)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                innerHTML: item.description,
                                class: "pt-2 description"
                            }, null, 8, _hoisted_9))
                            : _createCommentVNode("", true)
                    ]),
                    (item.imageUrl)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createElementVNode("div", {
                                class: _normalizeClass(['d-block ui-bordered border bg-white', _ctx.isItemSelect(item) ? 'border-success' : 'border-secondary']),
                                style: { "border-radius": "2px" }
                            }, [
                                _createElementVNode("img", {
                                    src: _ctx.$utils.mediaUrlWithSize(item.imageUrl, 200),
                                    width: "200"
                                }, null, 8, _hoisted_11)
                            ], 2),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(['btn w-100', _ctx.isItemSelect(item) ? 'btn-success' : 'btn-secondary']),
                                    onClick: _withModifiers(($event) => (_ctx.showDetails(item)), ["stop"])
                                }, "Details", 10, _hoisted_13)
                            ])
                        ]))
                        : (item.iconName)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(_component_g_icon, {
                                    src: item.iconName,
                                    class: "w-100 h-100"
                                }, null, 8, ["src"])
                            ]))
                            : _createCommentVNode("", true)
                ]),
                (_ctx.isItemSelect(item))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                        _createVNode(_component_g_icon, {
                            src: "/assets/icons/check.svg",
                            class: "w-100 h-100"
                        })
                    ]))
                    : _createCommentVNode("", true)
            ], 10, _hoisted_3));
        }), 256))
    ]));
}
